function Wrapper({ children }: { children: React.ReactNode }) {
  return <div>{children}</div>;
}

export default Wrapper;
